<template lang="pug">
  .pagination
    BPagination(
      v-if="paginationObject"
      :total='totalPages',
      :current="currentPage"
      :order="order",
      :simple='false',
      :size='size',
      :rounded='true',
      :per-page='perPage',
      aria-next-label='Next page',
      aria-previous-label='Previous page',
      aria-page-label='Page',
      aria-current-label='Current page'
      @change="actionWrapper"
    )
</template>

<script>
export default {
  name: "WtPagination",

  props: {
    paginationObject: {
      type: Object,
      default: null
    },

    action: {
      type: Function,
      default: () => {}
    },

    order: {
      type: String,
      default: ""
    },

    size: {
      type: String,
      default: "is-small"
    }
  },

  computed: {
    totalPages() {
      return this.paginationObject.total;
    },
    currentPage() {
      return this.paginationObject.currentPage;
    },
    perPage() {
      return this.paginationObject.perPage;
    }
  },

  methods: {
    actionWrapper($event) {
      this.$emit("currentPage", $event);
      this.action($event);
    }
  }
};
</script>

<style lang="sass" scoped>
.pagination
  margin-top: 10px
  width: 100%
</style>
